import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'

import LazyImage from '@/components/LazyImage'

export const CreateCustom: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className='relative z-[1] mx-auto max-w-[832px] px-4 text-center'>
      <span
        style={{
          background:
            'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
        }}
        className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:text-sm'
      >
        <Trans>Simple & Quick</Trans>
      </span>
      <H2 className='pt-3 font-normal md:pt-6 lg:font-bold'>
        <Trans>Create Custom AI Music In Minutes</Trans>
      </H2>
      <p className='text-f-other-10 pt-2 text-sm md:pt-3 md:text-xl'>
        <Trans>
          With Tad AI music generator, you can create songs or instrumentals
          fast and effortlessly. Simply input your prompt and any lyrics you
          have in mind, choose your preferred style, set custom settings and let
          our AI song generator take care of the rest.
        </Trans>
      </p>
      <LazyImage
        width={530}
        height={280}
        src={'/images/index/create-custom.png'}
        alt={t`Create Custom Music In Minutes`}
        className='mx-auto'
      />
    </div>
  )
}
